module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pluralo d-flex"
  }, [_c('pill'), _vm._v(" "), _c('sidebar'), _vm._v(" "), _c('section', {
    staticClass: "d-flex flex-column"
  }, [_c('div', [_c('bar'), _vm._v(" "), _c('topbar-message')], 1), _vm._v(" "), _c('router-view', {
    staticClass: "flexGrow1",
    nativeOn: {
      "click": function($event) {
        return _vm.clickOnContentArea()
      }
    }
  })], 1), _vm._v(" "), _c('modal-wrapper'), _vm._v(" "), (_vm.showNotifications) ? _c('floating-notifications') : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-3d4e8e3c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d4e8e3c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/Pluralo.vue
// module id = 1434
// module chunks = 0